export const PROTOCOL_REGEXP = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)/i;

export const PROTOCOL = {
  http: 'http://',
  https: 'https://',
};
